export enum Frequency {
  DAY = "day",
  WEEK = "week",
  MONTH = "month",
  QUARTER = "quarter",
  YEAR = "year"
}

export enum DayOfWeek {
  MONDAY = "monday",
  TUESDAY = "tuesday",
  WEDNESDAY = "wednesday",
  THURSDAY = "thursday",
  FRIDAY = "friday",
  SATURDAY = "saturday",
  SUNDAY = "sunday"
}

export enum DayOfQuarter {
  FIRST = "fiscal-first",
  LAST = "fiscal-last"
}

export enum DayOfYear {
  FIRST = "first",
  LAST = "last",
  FIRST_FISCAL = "fiscal-first",
  LAST_FISCAL = "fiscal-last"
}

export interface ScheduleData {
  frequencyCount: number;
  frequencyUnit: Frequency;
  dayOfPeriod: string | string[] | null;
  deliveryTime: string;
  timezone: string;
}

export interface PeriodFieldOption {
  id: string;
  displayName: string;
  subtitle?: string;
}

export interface PeriodFieldConfig {
  labelKey: string;
  defaultValue: string;
  options: PeriodFieldOption[];
  fixedOptions?: PeriodFieldOption[];
}

export type ScheduleSummaryStyle = "delivery" | "scheduledFor" | "recurring";
